import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import type {IUserStore} from "data/stores/user/user.store";
import {Bindings} from "data/constants/bindings";
import {createFanHubEvent} from "data/utils/helpers";

export interface IAuthController extends ViewController {
	get isAuthorized(): boolean;
	get wasLoggedOut(): boolean;
	get didRequestRorUser(): boolean;
	get isLoad(): boolean;

	trackRegEvent: () => void;
	trackLoginEvent: () => void;
}

@injectable()
export class AuthController implements IAuthController {
	constructor(@inject(Bindings.UserStore) private _userStore: IUserStore) {}

	get isAuthorized(): boolean {
		return this._userStore.isAuthorized;
	}

	get didRequestRorUser(): boolean {
		return this._userStore.didRequestRorUser;
	}

	get isLoad(): boolean {
		return this._userStore.isRequestingUser;
	}

	get wasLoggedOut(): boolean {
		return this._userStore.wasLoggedOut;
	}

	dispose(): void {
		return;
	}

	init(): void {
		return;
	}

	trackRegEvent = () => {
		createFanHubEvent("9932e071-86e6-43d4-9b9f-48decd0aa07e");
	};

	trackLoginEvent = () => {
		createFanHubEvent("03896baa-ee71-4d7b-917d-cf373f5363bd");
	};
}
